const OWNER_KEY = 'booking:accountOwner';
const ARCHIVE_PREFIX = 'bookingAccountEvidence:';

// Keep unknown-outcome evidence for its original account. Never reuse a passenger
// snapshot or vendor session for a different member, even when the email is the same.
export function prepareBookingAccount(memberIdx, storage = window.sessionStorage) {
  const nextOwner = memberIdx ? String(memberIdx) : 'guest';
  const previousOwner = storage.getItem(OWNER_KEY);
  const changed = previousOwner !== null && previousOwner !== nextOwner;
  const hasLegacyState = previousOwner === null && Object.keys(storage).some(key =>
    key.startsWith('booking:snapshot:') || key.startsWith('booking:submissionBlocked:')
    || key.startsWith('booking:createdReservation:'));
  // Guest cabin selection may carry into the first login. Known member state never does.
  const clear = hasLegacyState || (changed && previousOwner !== 'guest');
  if (clear) {
    const keys = Object.keys(storage).filter(key => key.startsWith('booking:') || key === 'bookingSessionKey');
    for (const key of keys) {
      if (key.startsWith('booking:submissionBlocked:')) {
        storage.setItem(`${ARCHIVE_PREFIX}${previousOwner || 'legacy'}:${key}`, storage.getItem(key));
      }
    }
    for (const key of keys) storage.removeItem(key);
  }
  storage.setItem(OWNER_KEY, nextOwner);
  // Restore only this account's safety blocks, never another account's form values.
  if (nextOwner !== 'guest') {
    const prefix = `${ARCHIVE_PREFIX}${nextOwner}:`;
    for (const key of Object.keys(storage)) {
      if (key.startsWith(prefix)) {
        storage.setItem(key.slice(prefix.length), storage.getItem(key));
        storage.removeItem(key);
      }
    }
  }
  return clear;
}
